import { render, staticRenderFns } from "./BaseMitChartBasic.vue?vue&type=template&id=17db508e&scoped=true"
import script from "./BaseMitChartBasic.vue?vue&type=script&lang=js"
export * from "./BaseMitChartBasic.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17db508e",
  null
  
)

export default component.exports